import Vue from 'vue'
import Vuelidate from 'vuelidate'

import App from '@/App.vue'
import router from '@/router'
import store from '@/store'

import InputMixin from '@/mixins/input'

import '@/main.css'

Vue.config.productionTip = false

Vue.mixin(InputMixin)

Vue.use(Vuelidate)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

store.dispatch('reset')
